// @ngInject
const VdcArticleWarningDialogService = ($mdDialog) => ({
  showDialog: () => {
    $mdDialog.show({
      clickOutsideToClose: true,
      controller: 'VdcArticleWarningDialogController as vm',
      templateUrl:
        'services/dialogs/vdcArticleWarningDialog/vdcArticleWarningDialog.tpl.html',
    });
  },
});

class VdcArticleWarningDialogController {
  constructor($mdDialog) {
    'ngInject';
    this.$mdDialog = $mdDialog;
  }
  close() {
    this.$mdDialog.cancel();
  }
}

angular
  .module('services.dialogs.vdcArticleWarningDialog', [])
  .service('VdcArticleWarningDialogService', VdcArticleWarningDialogService)
  .controller(
    'VdcArticleWarningDialogController',
    VdcArticleWarningDialogController,
  );
